export const sidebarStyles = {
  sidebarContent: width => ({
    width: width,
    bgcolor: 'background.paper',
    height: '100%',
    position: 'relative',
  }),

  drawerPaper: (width, theme) => ({
    width: width,
    boxSizing: 'border-box',
    border: 'none',
    boxShadow: theme.shadows[8],
  }),

  desktopSidebar: width => ({
    width: width,
    bgcolor: 'background.paper',
    height: '100%',
    borderRight: '1px solid',
    borderColor: 'grey.200',
    boxShadow: '2px 0 8px rgba(0,0,0,0.08)',
    position: 'relative',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      width: '1px',
      background:
        'linear-gradient(180deg, transparent 0%, rgba(0,0,0,0.1) 50%, transparent 100%)',
    },
  }),
};
